import React, { useState } from 'react';
import styles from './ManagerWorkplaceWrapper.module.scss';
import {
	useLazyWorkplacesListQuery,
	Workplace,
} from '../../../../../graphql/graphql';
import ManagerWorkplaceItem from '../ManagerWorkplaceItem/ManagerWorkplaceItem';
import ManagerWorkplaceToolbar from './ManagerWorkplaceToolbar';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import { useEffectAsync } from '../../../../../helpers';
import useLoading from '../../../../Base/Hooks/useLoading';
import buildWorkplaceTreeWithRoot from '../../../../Workplace/Helpers/Workplace/buildWorkplaceTreeWithRoot.helper';

export interface WorkplacesTreeItem extends Workplace {
	children: WorkplacesTreeItem[];
}

const ManagerWorkplaceWrapper = () => {
	const [workplacesTree, setWorkplacesTree] = useState<WorkplacesTreeItem[]>(
		[],
	);
	const { setIsLoading, isLoading, RenderLoading } = useLoading(true);
	const [getWorkplacesList] = useLazyWorkplacesListQuery();

	const handleLoadData = async () => {
		setIsLoading(true);
		const response = await getWorkplacesList();
		if (response.data?.workplaces?.data) {
			const items = buildWorkplaceTreeWithRoot(response.data.workplaces.data);
			setWorkplacesTree(items);
		}
		setIsLoading(false);
	};

	useEffectAsync(async () => {
		await handleLoadData();
	}, []);

	if (isLoading) {
		return <RenderLoading />;
	}

	return (
		<div className={styles.wrapper}>
			<ManagerWorkplaceToolbar onCreate={handleLoadData} />
			<div className={styles.list}>
				<ScrollContainer className={styles.scrollContainer}>
					{workplacesTree.map(item => (
						<ManagerWorkplaceItem
							key={item.id}
							item={item}
							onChange={handleLoadData}
						/>
					))}
				</ScrollContainer>
			</div>
		</div>
	);
};

export default ManagerWorkplaceWrapper;
